enum COOKIES {
  browserCookieId = 'BrowserCookieId',
  correspondingEventId = 'vdp-corresponding-event-id',
  nativeAppVersion = 'X-CVNA-AppVersion',
  nativeHomeInView = 'nativeHomeInView',
  preferredTrade = 'merch-preferred-trade',
  searchRequestId = 'searchRequestId',
  searchSessionId = 'merch-search-session-id',
  sebastianReadiness = 'X-CVNA-SebastianReadiness',
  srpResume = 'merch-srp-resume',
  tradeInApplied = 'merch-tradein-applied'
}

export default COOKIES;
